"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _errorMessageModule = _interopRequireDefault(require("./error-message.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorMessage = function ErrorMessage(_ref) {
  var error = _ref.error,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_errorMessageModule["default"].errorMessage, className)
  }, error);
};

ErrorMessage.propTypes = {
  error: _propTypes["default"].node,
  className: _propTypes["default"].string
};
ErrorMessage.defaultProps = {
  error: '',
  className: ''
};
var _default = ErrorMessage;
exports["default"] = _default;